var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvert3DCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8333 46.25C67.8333 58.1825 58.1825 67.8333 46.25 67.8333L49.4875 62.4375",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 27.75C6.16667 15.8175 15.8175 6.16663 27.75 6.16663L24.5125 11.5625",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2417 13.7208L54.5133 20.8125L66.6617 13.7517",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5133 33.3617V20.7816",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.615 6.81413L44.215 10.9148C42.55 11.8398 41.1625 14.1831 41.1625 16.0948V23.9266C41.1625 25.8383 42.5192 28.1816 44.215 29.1066L51.615 33.2075C53.1875 34.1016 55.7775 34.1016 57.3808 33.2075L64.7808 29.1066C66.4458 28.1816 67.8333 25.8383 67.8333 23.9266V16.0948C67.8333 14.1831 66.4767 11.8398 64.7808 10.9148L57.3808 6.81413C55.8083 5.95079 53.2184 5.95079 51.615 6.81413Z",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24585 47.6375L19.4867 54.7291L31.6658 47.6683",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4867 67.2783V54.6982",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8375 50.0423C32.8375 48.1306 31.4808 45.7873 29.785 44.8623L22.385 40.7614C20.8125 39.8673 18.2225 39.8673 16.6192 40.7614L9.21918 44.8623C7.55418 45.7873 6.16667 48.1306 6.16667 50.0423V57.8741C6.16667 59.7858 7.52335 62.1291 9.21918 63.0541L16.6192 67.155C18.1917 68.0491 20.7817 68.0491 22.385 67.155L29.785 63.0541",
    stroke: "#FF007A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert3DCube);
export default __webpack_public_path__ + "static/media/convert-3d-cube.b1a7bfc62bab0fae7febe1493e4f9aed.svg";
export { ForwardRef as ReactComponent };